import React from 'react';
import { Container, Eyebrow, H2, Reveal } from './shared';

export const About = () => (
  <section className="bg-paper py-20 sm:py-28" data-testid="about-section">
    <Container className="grid items-center gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
      <Reveal>
        <img
          src="/about-photo.jpg"
          alt="Bican Coskun mit ausgebreiteten Armen an einer Klippe über dem Meer"
          loading="lazy"
          decoding="async"
          width="900"
          height="1200"
          className="mx-auto aspect-[4/5] w-full max-w-[420px] rounded-[28px] border border-line object-cover object-center"
          data-testid="about-portrait"
        />
      </Reveal>
      <Reveal delay={100}>
        <Eyebrow>Über mich</Eyebrow>
        <H2>Ich war genau da, wo du jetzt stehst.</H2>
        <div className="mt-6 space-y-5 text-base leading-relaxed text-ink sm:text-[17px]">
          <p>Ich habe mit 14, 15 angefangen zu arbeiten und früh gemerkt: Wer nur von einem Gehalt lebt, ist abhängig. Also habe ich gespart und irgendwann verstanden, dass Sparen allein nicht reicht.</p>
          <p>Nach meinem Master in Business Administration habe ich in der Buchhaltung und Wirtschaftsprüfung gearbeitet. Dort habe ich gelernt, Bilanzen wirklich zu lesen. Genau das Handwerk, das ich dir heute beibringe.</p>
          <p>Dann kam der Corona-Crash, und ich wurde im Unternehmen plötzlich nicht mehr gebraucht. Seitdem weiß ich: Ohne zweites Standbein bist du ausgeliefert. Heute investiere ich in Dividenden-Aktien, bin mit meiner Frau auf Weltreise und werde jeden Monat ein Stück unabhängiger.</p>
          <p className="font-bold text-white">Diesen Weg gebe ich weiter, damit du nicht so lange brauchst wie ich.</p>
        </div>
      </Reveal>
    </Container>
  </section>
);
